import React, {useContext, useEffect, useState} from 'react';
import {Link, useParams} from 'react-router-dom';
import {DataContext} from '../../context/dataContext';
import {API, verifySite} from '../../utils/api';
import arrow from '../../assets/images/arrow.svg';
import Loader from '../../components/Loader';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import RSFront from '../../components/cars/front/RS';
import {Helmet} from 'react-helmet';
import useRecaptcha from '../../hooks/useRecaptcha';
import useWindowSize from '../../hooks/useWindowSize';
const Enquiry = () => {
  const params = useParams();
  const dataContext = useContext(DataContext);
  const [lodding, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState();
  const [token] = useRecaptcha();
  const [dataapi, setDataApi] = useState();
  const [width, height] = useWindowSize();
  useEffect(() => {
    dataContext?.setLoading(true);
    API(`regs?id=${params?.id}`, 'get', '', '')
      .then((res) => {
        console.log('chckout res: ', res);
        setData(res?.data);

        dataContext?.setLoading(false);
      })
      .catch((e) => {
        dataContext?.setLoading(false);
        console.log('get data error: ', e);
      });
  }, []);

  const vattotalAmount = data?.vat
    ? formatNumber(parseFloat(Number(data?.sales)).toFixed(2))
    : formatNumber(parseFloat(Number(data?.sales)).toFixed(2));

  function removeCommas(numberString) {
    return parseFloat(numberString.replace(/,/g, ''));
  }

  const formattedNumber = vattotalAmount;
  const total = removeCommas(formattedNumber);
  console.log(total);

  // Function to calculate VAT
  function calculateVAT(amount) {
    return amount * 0.2;
  }
  var amount = total;
  var vat = calculateVAT(amount);

  console.log('vatAmount --------->', vat);

  const formik = useFormik({
    initialValues: {
      first_name: '',
      middle_initials: '',
      last_name: '',
      email: '',
      phone_no: '',
      description: '',
      subscribe: false,
      submitting: false,
    },
    validationSchema: Yup.object({
      first_name: Yup.string()
        .matches(/^[A-Za-z\s]*$/, 'Invalid characters')
        .required('Please enter first name'),
      middle_initials: Yup.string()
        .matches(/^[A-Za-z\s]*$/, 'Only characters')
        .notRequired(),
      last_name: Yup.string()
        .matches(/^[A-Za-z\s]*$/, 'Invalid characters')
        .required('Please enter last name'),

      email: Yup.string()
        .email('Invalid email')
        .required('Please enter your email.')
        .matches(/@.*\./, 'Domain name is required'),

      phone_no: Yup.string()
        .transform((value) => (value ? value.replace(/\s/g, '') : value)) // Remove spaces
        // .matches(/^\d{10}$/, 'Phone number must be exactly 10 digits')
        .required('Please enter phone number'),

      submitting: Yup.boolean().oneOf(
        [true],
        'By submitting this form, you are agreeing to REG247’s',
      ),

      description: Yup.string().required('Please enter description'),
      subscribe: Yup.boolean().notRequired(),
    }),

    onSubmit: (values) => {
      verifySite(token);
      // Your login logic here using the form values
      // For example, you can authenticate the user and navigate upon successful login
      const {
        first_name,
        middle_initials,
        last_name,
        email,
        phone_no,
        description,
        subscribe,
      } = values;

      console.log('values', first_name);

      setLoading(true);
      try {
        const body = {
          first_name: first_name,
          middle_initials: middle_initials,
          last_name: last_name,
          email: email,
          phone_number: phone_no,
          message: description,
          is_subscribe: subscribe,
          reg: data?.reg,
          isCommentRead: false,
          id: data?._id,
        };

        console.log('body', body);

        API('inquiry', 'post', body, '')
          .then((response) => {
            document.querySelector('body').scrollTo(0, 0);
            setLoading(false);
            setVisible(true);
            formik.resetForm();
            console.log('responce', response);
            setDataApi(response);
          })
          .catch((error) => {
            setLoading(false);
            console.log('catch error:', error);
          });
      } catch (error) {
        console.log('catch error message: ', error);

        setLoading(false);
      }
      // Perform authentication logic here...

      // For demonstration purposes, let's assume authentication is successful
      // Redirect the user to the home page
      // localStorage.setItem(constants.USER, email); // Storing user in localStorage
      // navigate('/');
    },
  });
  let nonSpaceEntered = false;
  const renderToast = () => {
    return (
      <div
        className={`alert alert-success text-start d-flex border-0 align-items-center justify-content-between ${
          visible ? 'visible' : 'hidden'
        }`}>
        <span>
          Thank you for your enquiry. One of the team will be in touch very
          soon.
        </span>
        <span
          role="button"
          className="close-btn"
          onClick={() => setVisible(false)}>
          &#x2715;
        </span>
      </div>
    );
  };

  function formatNumber(num) {
    // Convert the number to a string, handling different input types
    var numberString = typeof num === 'number' ? num.toString() : String(num);

    // Handle non-decimal numbers by adding ".00"
    if (!numberString.includes('.') && numberString !== '0') {
      numberString += '.00';
    }

    // Split the number into integer and decimal parts
    var parts = numberString.split('.');

    // Format the integer part with commas using Intl.NumberFormat
    var formatter = new Intl.NumberFormat('en-US');
    var formattedInteger = formatter.format(parseInt(parts[0], 10));

    // Combine the formatted integer and decimal parts
    var formattedNumber = formattedInteger + (parts[1] ? '.' + parts[1] : '');

    return formattedNumber;
  }

  return (
    <div className="main__page__content ">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{`Enquire ${params?.id} Registration`}</title>
      </Helmet>
      {lodding && <Loader />}
      <main>
        <div className="reg__enquiry">
          <div className="reg__enquiry--data pt-45 pb-45">
            <div className="container">
              <h2 className="f36 fsi text-white">
                Prefer to speak with us over the phone?{' '}
                <span className="text-green f36 fsi">
                  Call us on{' '}
                  <a className="text-green f36 fsi" href="tel:01582347734">
                    <u>
                      <b>01582 347734</b>
                    </u>
                  </a>
                </span>
              </h2>
            </div>
          </div>
        </div>
        <section className="reg__enquiry--section pt-45 pb-45">
          <div className="container">
            {visible && width < 768 && renderToast()}
            <div className="reg__section--heading mb-30">
              <h1 className="f36 fys">Registration Enquiry</h1>
            </div>
            <h5 className="fys text-300 lh32 mb-35">How can we help?</h5>
            <div className="reg__data--section reg__enquiry__form row">
              <div className="col-12 col-lg-5 order-2 order-lg-2">
                <div className="reg__car--details">
                  {/* <img
                    src={require('../../assets/images/car5.png')}
                    alt="image"
                    className="mb-23"
                  /> */}
                  <RSFront numberPlate={data?.reg} />
                  <p className="fsi">
                    {data?.displaymsg}
                    {/* This registration can only be transferred onto a vehicle
                    registered&nbsp;on or after March 1 1999, or keep it for
                    later on a DVLA certificate. */}
                  </p>
                  <div className="separator" />
                  <div className="reg__plate--title">
                    <div className="d-flex justify-between fsi text-400">
                      <p className="mb-0">Registration:</p>
                      <p className="mb-0">
                        £{formatNumber(parseFloat(data?.sales).toFixed(2))}
                      </p>
                    </div>
                    <div className="reg__price--line" />
                    <div className="d-flex justify-between fsi text-400">
                      <p className="mb-0">Compulsory DVLA transfer fee:</p>
                      <p className="mb-0">£80.00</p>
                    </div>
                    <div className="reg__price--line" />
                    {data?.vat ? (
                      <>
                        <div className="d-flex justify-between fsi text-400">
                          <p className="mb-0">VAT:</p>
                          <p className="mb-0">
                            £{formatNumber(parseFloat(vat).toFixed(2))}
                          </p>
                        </div>
                        <div className="reg__price--line" />
                      </>
                    ) : null}
                    <div className="d-flex justify-between text-400">
                      <p className="mb-0 fsi f20">Total</p>
                      <p className="mb-0 fsi f20">
                        £
                        {data?.vat
                          ? formatNumber(
                              parseFloat(
                                Number(data?.sales) + vat + 80,
                              ).toFixed(2),
                            )
                          : formatNumber(
                              parseFloat(Number(data?.sales) + 80).toFixed(2),
                            )}
                      </p>
                    </div>
                    <div className="reg__price--greenline" />
                    {/* <div class="reg__payment--image d-flex justify-between">
                                   <img src="assets/images/mastervisa.png" alt="image">
                                   <img src="assets/images/reviews.png" alt="image">
                                   <img src="assets/images/poweredbystripe.png" alt="image">
                               </div> */}
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-7 order-1 order-lg-1">
                {visible && width > 768 && renderToast()}

                {dataapi?.message === 'Success' ? (
                  <div></div>
                ) : (
                  <div className="reg__list--data border rounded-2 p-45 pt-30">
                    <form
                      className="row fsi text-400 enquiry__form"
                      onSubmit={formik.handleSubmit}>
                      {/* First Name */}
                      <div className="col-12 col-md-4 mb-15">
                        <label className="f16 mb-10" htmlFor="">
                          First Name
                          <span className="reg__iimportant f24">*</span>
                        </label>
                        <div className="input-group bg-image">
                          <input
                            type="text"
                            className="form-control p16 border-0"
                            id="inputAddress"
                            placeholder="First Name"
                            value={formik.values.first_name}
                            onChange={(e) => {
                              formik.setFieldValue(
                                'first_name',
                                e.target.value?.trimStart(),
                              );
                            }}
                          />
                        </div>
                        {formik.touched.first_name &&
                          formik.errors.first_name && (
                            <div className="text-danger">
                              {formik.errors.first_name}
                            </div>
                          )}
                      </div>
                      {/* Surname */}
                      <div className="col-12 col-sm-5 col-md-3 mb-15">
                        <label className="f16 mb-10" htmlFor="">
                          Middle Initials
                        </label>
                        <div className="input-group bg-image">
                          <input
                            type="text"
                            className="form-control p16 border-0"
                            id="inputAddress2"
                            placeholder="Initial"
                            value={formik.values.middle_initials}
                            onChange={(e) => {
                              formik.setFieldValue(
                                'middle_initials',
                                e.target.value?.trimStart(),
                              );
                            }}
                          />
                        </div>
                        {formik.touched.middle_initials &&
                          formik.errors.middle_initials && (
                            <div className="text-danger">
                              {formik.errors.middle_initials}
                            </div>
                          )}
                      </div>
                      {/* Email */}
                      <div className="col-12 col-sm-7 col-md-5 mb-15">
                        <label className="f16 mb-10" htmlFor="">
                          Last Name
                          <span className="reg__iimportant f24">*</span>
                        </label>
                        <div className="input-group bg-image">
                          <input
                            type="text"
                            className="form-control p16 border-0"
                            id="inputCity"
                            placeholder="Last Name"
                            value={formik.values.last_name}
                            onChange={(e) => {
                              formik.setFieldValue(
                                'last_name',
                                e.target.value?.trimStart(),
                              );
                            }}
                          />
                        </div>
                        {formik.touched.last_name &&
                          formik.errors.last_name && (
                            <div className="text-danger">
                              {formik.errors.last_name}
                            </div>
                          )}
                      </div>
                      {/* Confirm Email */}
                      <div className="col-12 col-md-6 mb-15">
                        <label className="f16 mb-10" htmlFor="">
                          Email<span className="reg__iimportant f24">*</span>
                        </label>
                        <div className="input-group bg-image">
                          <input
                            type="text"
                            className="form-control p16 border-0"
                            id="inputCity"
                            placeholder="example@mail.com"
                            value={formik.values.email}
                            onChange={(e) => {
                              formik.setFieldValue(
                                'email',
                                e.target.value?.trimStart(),
                              );
                            }}
                          />
                        </div>
                        {formik.touched.email && formik.errors.email && (
                          <div className="text-danger">
                            {formik.errors.email}
                          </div>
                        )}
                      </div>
                      {/* Phone */}
                      <div className="col-12 col-md-6 mb-15">
                        <label className="f16 mb-10" htmlFor="">
                          Phone <span className="reg__iimportant f24">*</span>
                        </label>
                        <div className="input-group bg-image fnumber">
                          {/* <div className="input-group-text border-0 rounded-0 bg-transparent p15 green-image border-end br-2 border-color">
                            +44
                          </div> */}
                          <input
                            type="text"
                            className="form-control p16 border-0"
                            id="inputCity"
                            placeholder="Phone"
                            value={formik.values.phone_no}
                            // onChange={(e) => {
                            //   const inputValue = e.target.value
                            //     ?.trimStart()
                            //     .slice(0, 10); // Limit input to 11 characters
                            //   formik.setFieldValue('phone_no', inputValue);
                            // }}
                            onChange={(e) => {
                              let input = e.target.value;
                              const regex = /^[0-9\s]*$/; // Regular expression to allow only numbers and spaces
                              if (!nonSpaceEntered) {
                                // If no non-space character entered yet, trim spaces
                                input = input.trimStart();
                              }
                              if (regex.test(input) || input === '') {
                                formik.setFieldValue('phone_no', input);
                                // Check if a non-space character has been entered
                                if (input !== '' && !nonSpaceEntered) {
                                  nonSpaceEntered = true;
                                }
                              }
                            }}
                            // onChange={(e) => {
                            //   formik.setFieldValue(
                            //     'phone_no',
                            //     e.target.value?.trimStart(),
                            //   );
                            // }}
                          />
                        </div>
                        {formik.touched.phone_no && formik.errors.phone_no && (
                          <div className="text-danger">
                            {formik.errors.phone_no}
                          </div>
                        )}
                      </div>
                      {/* Street Address */}
                      <div className="col-12 mb-50">
                        <label className="f16 mb-10" htmlFor="">
                          Message<span className="reg__iimportant f24">*</span>
                        </label>
                        <div className="form__price input-group bg-image">
                          <textarea
                            type="text"
                            className="form-control p16 border-0"
                            rows={6}
                            cols={5}
                            id="inputCity"
                            placeholder="Write here"
                            defaultValue={''}
                            value={formik.values.description}
                            onChange={(e) => {
                              formik.setFieldValue(
                                'description',
                                e.target.value?.trimStart(),
                              );
                            }}
                          />
                        </div>
                        {formik.touched.description &&
                          formik.errors.description && (
                            <div className="text-danger">
                              {formik.errors.description}
                            </div>
                          )}
                      </div>

                      <div className="col-12">
                        <div
                          className="form-check mb-20 "
                          style={{alignItems: 'center'}}>
                          <input
                            id="unsubscribe1"
                            className="form-check-input"
                            type="checkbox"
                            checked={formik.values.submitting}
                            onChange={(e) =>
                              formik.setFieldValue(
                                'submitting',
                                e.target.checked,
                              )
                            }
                          />
                          <label
                            className={
                              formik.touched.submitting &&
                              formik.errors.submitting
                                ? 'form-check-label text-danger pl-9 '
                                : 'form-check-label pl-9 '
                            }
                            htmlFor="unsubscribe1">
                            By submitting this form, you are agreeing to
                            REG247’s{' '}
                            <Link
                              to="/privacy-policy"
                              className="privacy-link"
                              rel="noopener" rel="noreferrer" target="_blank">
                              <span
                                // className="f16"
                                className={
                                  formik.touched.submitting &&
                                  formik.errors.submitting
                                    ? 'form-check-label text-danger f16 '
                                    : 'form-check-label f16'
                                }
                                style={{textDecorationLine: 'underline'}}>
                                privacy policy
                              </span>
                            </Link>
                            <span className="f24">*</span>
                          </label>
                        </div>
                      </div>

                      <div className="col-12 mb-15">
                        <div className="form-check mb-50">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="unsuscribe"
                            checked={formik.values.subscribe}
                            onChange={(e) =>
                              formik.setFieldValue(
                                'subscribe',
                                e.target.checked,
                              )
                            }
                          />
                          <label
                            className="form-check-label  text-400 lh28 mb-15 pl-9"
                            htmlFor="unsuscribe">
                            Subscribe for special offers, discounts and number
                            plates that may be relevant to me. I understand that
                            I can unsubscribe at any time.
                          </label>
                          {/* <p className="f16 pl-9" htmlFor="unsuscribe">
                            We will not share your details with any third
                            parties. We may contact you in accordance with
                            our&nbsp;{' '}
                            <Link to={'/privacy-policy'} className="f16">
                              <u>Privacy Policy</u>
                            </Link>
                            . You can unsubscribe any time.
                          </p> */}
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="form-check fsubmit_btn mb-0">
                          <button
                            type="submit"
                            className="reg__sell--submit btn text-uppercase f24 lh14 d-flex align-center justify-center">
                            SEND{' '}
                            <img
                              className="in-svg ml-25"
                              src={arrow}
                              alt="Arrow image"
                            />
                          </button>
                        </div>
                      </div>
                      {/* </div> */}
                    </form>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};
export default Enquiry;
